<template>
  <div class="txt-in-img-section">
    <div class="txt-in-img-item" :class="isMobile ? '' : 'fill-section-1080'" v-for="(item, index) in txtImgList" :key="index">
      <img class="img-cover" :src="isMobile ? item.mobileImg : item.img" :alt="item.tag" />
      <div class="txt-wrap" :class="[isMobile ? mobileFontColor : item.txtLayout, item?.color ? item.color : '']" >
        <p class="txt-tag fade-up" v-if="item.tag">{{ item.tag }}</p>
        <p class="txt-title fade-up" v-if="item.title" v-html="item.title"></p>
        <p class="txt-desc fade-up" v-if="item.desc" v-html="item.desc"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  name: 'CarTxtInImgList',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    txtImgList: {
      type: Array,
      required: true
    },
    mobileFontColor: {
      type: String,
      default: 'dark'
    },
  },
  mounted() {
    fadeAnimate();
  },
  beforeDestroy() {
    destroyFadeAnimate();
  },
  data() {
    return {

    }
  },
}
</script>

<style lang="less" scoped>
.txt-in-img-section {
  width: 100%;
  .txt-in-img-item {
    .txt-wrap {
      position: absolute;
      &.left-top {
        left: 4.88vw;
        top: 4.17vw;
      }
      &.left-top2 {
        left: 22.4vw;
        top: 4.17vw;
        .txt-tag {
          color: #999999;
        }
        .txt-desc {
          color: #666666;
        }
        .txt-title {
          color: #222222;
        }
      }
      &.left-top3 {
        left: 4.88vw;
        top: 4.17vw;
        .txt-tag {
          color: #999999;
        }
        .txt-desc {
          color: #666666;
        }
        .txt-title {
          color: #222222;
        }
      }
      &.left-top4 {
        left: 3.42vw;
        top: 4.88vw;
        .txt-tag {
          color: #999999;
        }
        .txt-desc {
          color: #666666;
        }
        .txt-title {
          color: #222222;
        }
      }
      &.center-top {
        top: 4.17vw;
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
        .txt-tag {
          color: #999999;
        }
        .txt-desc {
          color: #666666;
        }
        .txt-title {
          color: #222222;
        }
      }
      &.center-top2 {
        top: 4.17vw;
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
        .txt-tag {
          color: rgba(255, 255, 255, 0.7);
          font-size: clamp(12px, 0.83vw, 16px);
        }
        .txt-title {
          color: #ffffff;
           font-size: clamp(32px, 2.5vw, 48px);
          line-height: 1.2;
        }
        .txt-desc {
          color: rgba(255, 255, 255, 0.7);
          font-size: clamp(16px, 1.25vw, 24px);
        }
      }
      &.right-top {
        top: 4.88vw;
        right: 4.88vw;
        .txt-tag, .txt-desc {
          color: rgba(255, 255, 255, 0.7);
        }
        .txt-title {
          color: #ffffff;
        }
      }
      &.right-center {
        top: 50%;
        transform: translateY(-50%);
        right: 4.88vw;
        .txt-tag, .txt-desc {
          color: rgba(255, 255, 255, 0.7);
        }
        .txt-title {
          color: #ffffff;
        }
      }
      &.right-center2 {
        right: 4.88vw;
        top: 50%;
        transform: translateY(-50%);
        .txt-tag {
          color: #999999;
        }
        .txt-desc {
          color: #666666;
        }
        .txt-title {
          color: #222222;
        }
      }
      &.none {
        display: none;
      }
      .txt-tag {
        font-size: clamp(12px, 0.83vw, 16px);
        font-weight: @fw2;
        color: #060606;
      }
      .txt-title {
        font-size: clamp(38px, 2.5vw, 48px);
        font-weight: @fw1;
        line-height: 1.2;
        color: #222222;
        margin: 0.83vw 0;
      }
      .txt-desc {
        font-size: clamp(16px, 1.25vw, 24px);
        font-weight: @fw2;
        color: #666666;
        line-height: 1.4;
      }
    }
    .light {
      .txt-tag, .txt-title, .txt-desc {
        color: #fff;
      }
    }
  }
  
}
@media (max-width: @mobile-width) {
  .txt-in-img-section {
    .txt-in-img-item {
      position: relative;
      .txt-wrap {
        position: absolute;
        inset: 0;
        color: #212020;
        text-align: center;
        padding-top: 21.33vw;
        .txt-tag {
          font-size: 4.26vw;
          font-weight: @fw2;
          letter-spacing: 1.07vw;
        }
        .txt-title {
          font-size: 8.53vw;
          line-height: 1.2;
          margin: 1.6vw auto;
          font-weight: @fw1;
        }
        .txt-desc {
          font-size: 4.26vw;
          line-height: 1.6;
          padding: 0 4.26vw;
          font-weight: @fw2;
        }
      }
      .dark {
        .txt-tag, .txt-title, .txt-desc {
          color: #212020;
        }
      }
      .light {
        .txt-tag, .txt-title, .txt-desc {
          color: #fff;
        }
      }
    }
  }
}
</style>